<template>
  <modal
    class="cardActionModal"
    name="cardActionModal"
    transition="pop-out"
    :width="modalWidth"
    :height="490"
  >
    <div class="desktop-modal-container home_modal_container">
      <div class="left-modal-view">
        <!-- <img src="@/assets/img/remis-fleet.png"  /> -->
        <!-- <remis-card :cardNumber="cardNumberSelected"></remis-card> -->
        <div class="p-1 remis-card-conainer">
          <img src="@/assets/img/Group 2575.png" class="" />
          <div class="dash-card-container">
            <h3 class="text-black card-number-text">
              {{ passedInfo.cardNumber }}
            </h3>
          </div>
        </div>
      </div>
      <div class="right-modal-view pt-1">
        <div class="section-wrapper">
          <div class="text-center modal_header">{{ passedInfo.action }}</div>
          <form class="mt-4">
            <div class="mt-1" v-if="passedInfo.action == 'Change Pin'">
              <label>{{ $t("text.addCardVehicle.oldPin") }}</label>
              <div class="form_input">
                <input
                  type="password"
                  maxlength="4"
                  class="form-control"
                  v-model="oldPin"
                />
              </div>
            </div>
            <div class="mt-1" v-if="passedInfo.action == 'Change Pin'">
              <label>{{ $t("text.addCardVehicle.newPin") }}</label>
              <div class="form_input">
                <input
                  type="password"
                  maxlength="4"
                  class="form-control"
                  v-model="newPin"
                />
              </div>
            </div>
            <div class="mt-1" v-if="passedInfo.action == 'Block Card'">
              <label>{{ $t("text.addCardVehicle.pin") }}</label>
              <div class="form_input">
                <input
                  type="password"
                  maxlength="4"
                  class="form-control"
                  v-model="pin"
                />
              </div>
            </div>
            <div class="mt-3">
              <div class="form_input">
                <button
                  class="rem-btn w-100 main mobile-btn-height gold_color"
                  @click="
                    passedInfo.action == 'Change Pin'
                      ? changePin($event)
                      : blockCard($event)
                  "
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ passedInfo.action }}
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="25px"
                    class="ml-3 loader"
                  />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "cardActionModal",
  props: ["passedInfo"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      oldPin: null,
      newPin: null,
      pin: null,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth = 850;
  },
  methods: {
    closeAddCardModal() {
      this.$modal.hide("cardActionModal");
    },
    generateRandomNumber() {
      return Math.floor(Math.random() * 9);
    },
    formatPin(pin) {
      let randNum1 = this.generateRandomNumber();
      let randNum2 = this.generateRandomNumber();
      let randNum3 = this.generateRandomNumber();

      const two = pin.substring(0, 2);
      const lastTwo = pin.slice(2);
      return `${randNum1}${two}${randNum2}${lastTwo}${randNum3}`;
    },
    changePin($event) {
      $event.preventDefault();

      if (!this.oldPin) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.oldPinError"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (this.oldPin.length !== 4) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.fourDigitErr"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.newPin) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.newPinErr"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.newPin.length !== 4) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.newPinFourErr"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      const data = {
        oldPin: this.formatPin(this.oldPin),
        newPin: this.formatPin(this.newPin),
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Card/ChangePin/${this.passedInfo.uniqueId}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.addCardVehicle.successfullyChangedPin"),
            type: "success",
            duration: 3000,
          });
          this.oldPin = null;
          this.newPin = null;
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$modal.hide("cardActionModal");
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    blockCard(e) {
      e.preventDefault();
      this.$router.push({ name: "vehicle" });
      return;

      if (!this.pin) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.pinError"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.pin.length !== 4) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.fourDigitErr"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      const data = {
        pin: this.formatPin(this.pin),
      };

      let resp = confirm(this.$t("text.addCardVehicle.sureBlockCard"));
      if (resp) {
        $(".loader").show();
        this.isButtonDisabled = true;

        this.axios
          .put(
            `${configObject.apiBaseUrl}/Card/Block/${this.passedInfo.uniqueId}`,
            data,
            configObject.authConfig()
          )
          .then((res) => {
            this.$toast.open({
              message: this.$t("text.addCardVehicle.successfullyBlockedCard"),
              type: "success",
              duration: 3000,
            });
            $(".loader").hide();
            this.isButtonDisabled = false;
            this.$modal.hide("cardActionModal");
            this.$router.push({ name: "vehicle" });
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 3000,
            });
            $(".loader").hide();
            this.isButtonDisabled = false;
          });
      }
    },
  },
};
</script>
